import { render } from "./CandidateDashboard.vue?vue&type=template&id=adf50362&scoped=true"
import script from "./CandidateDashboard.vue?vue&type=script&lang=js"
export * from "./CandidateDashboard.vue?vue&type=script&lang=js"

import "./CandidateDashboard.vue?vue&type=style&index=0&id=adf50362&scoped=true&lang=css"

import exportComponent from "C:\\RsystemsWork\\Informative Work\\CD-UAT\\creditdriver\\CreditDriver\\CandidateApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adf50362"]])